const deliveryTimeRangesModel = vm => ({
  title: vm.$gettext('Delivery Time Ranges'),
  endpoint: 'delivery-time-ranges',
  allowNew: true,
  countrizeById: 'country_id',
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('A name to identify the range like "morning" or "afternoon"')
    },
    {
      key: 'description',
      label: vm.$gettext('Description'),
      sortable: false,
      editable: true,
      required: false,
      description: vm.$gettext('Optional description for the time range')
    },
    {
      key: 'country_id',
      label: vm.$gettext('Country'),
      sortable: true,
      editable: true,
      type: 'select',
      options: 'countriesById',
      showKey: 'id',
      showField: 'name',
      withSelect: true
    },
    {
      key: 'time_from',
      label: vm.$gettext('Time From'),
      sortable: false,
      editable: true,
      required: true,
      description: vm.$gettext('Time where this time range starts. Format hh:mm:ss'),
      type: 'time',
      step: 1,
      withSeconds: true
    },
    {
      key: 'time_to',
      label: vm.$gettext('Time To'),
      sortable: false,
      editable: true,
      required: true,
      description: vm.$gettext('Time where this time range ends. Format hh:mm:ss'),
      type: 'time',
      step: 1,
      withSeconds: true
    }
  ],
  filters: ['name', 'country_id']
})

export default deliveryTimeRangesModel
